export default __webpack_public_path__ + "static/media/academy.c7a89823.png";